import { ICellRendererParams } from 'ag-grid-community';
import { IContactPositionForList } from '@nkr/models/index';
import React from 'react';

const Roles = (props: ICellRendererParams) => {
    const roles = props.value as IContactPositionForList[];

    if (roles.length == 1 && roles[0].id == -1) {
        return <span>[not specified]</span>;
    }

    const rolesText = roles.map(r => r.description).join(', ');

    return (
        <div
            title={rolesText}
            style={{ fontSize: 12, lineHeight: '20px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
        >
            {rolesText}
        </div>
    );
};

export default Roles;
